import React, {useEffect, useState} from "react";
import {useSelector} from "react-redux";
import {Backdrop, Button, CircularProgress, Container, styled, Tooltip} from "@mui/material";
import {ApiUrl} from "../utils/portal-urls";
import RefreshIcon from '@mui/icons-material/Refresh';
import {handleHttpResponse} from "../utils/http-helpers";
import ExternalSourceTable from "./ExternalSourceTable";
import ShowSnackbar from "../utils/ShowSnackbar";

const StyledContainer = styled(Container)(({theme}) => ({
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
}))
export const batchCurrentStatus = {
    Init: {
        getStatus: 'info',
        getMsg: () => "No Active Process"
    },
    Running: {
        getStatus: 'info',
        getMsg: (source) => `Currently Running ${source} Import Process`
    },
    Completed: {
        getStatus: 'success',
        getMsg: (source) => `${source} Import Process Completed`
    },
    Cancelled: {
        getStatus: 'warning',
        getMsg: (source) => `${source} Import Process has been Canceled`
    },
    Interrupted: {
        getStatus: 'warning',
        getMsg: (source) => `${source} Import Process has been Interrupted`
    },
    Failed: {
        getStatus: 'error',
        getMsg: (source) => `${source} Import Process Failed`
    },
}


export default function ExternalSourceManagementHome() {
    const account = useSelector(state => state.userAccount.userAccount);

    const [onRefresh, setRefresh] = useState(new Date().getTime());
    const [allSourcesData, setAllSourcesData] = useState(null);
    const [loading, setLoading] = useState(false);
    const [snackbarOpen, setSnackbarOpen] = useState(false);

    useEffect(() => {
        fetchAllSources();
    }, [onRefresh])

    const fetchAllSources = () => {
        setLoading(true);
        const url = ApiUrl.ExternalSource.getAllSources.getPath();
        console.log("Getting all sources data: " + url);

        fetch(url)
            .then(handleHttpResponse)
            .catch( err => {
                setLoading(false);
                if (err) {
                    console.error(err);
                    setSnackbarOpen(true);
                }
            })
            .then( res => {
                setLoading(false);
                if (res) {
                    setAllSourcesData(res);
                }
            })
    }

    const handleRefresh = () => {
        setRefresh(new Date().getTime());
    }

    return (
        <StyledContainer>
            <h2 className="title" style={{display: 'flex', justifyContent: 'space-between'}}>
                <span>External Sources</span>
                <Tooltip title="Refresh to get the latest update">
                    <Button variant='outlined' sx={{float: 'right'}} onClick={handleRefresh} endIcon={<RefreshIcon />}>Refresh</Button>
                </Tooltip>
            </h2>
            {allSourcesData && <ExternalSourceTable allSourceData={allSourcesData} />}
            <ShowSnackbar open={snackbarOpen} close={(c) => setSnackbarOpen(c)} msg={{msg: "Failed to get external source logs", msgLv: "error"}} />
            <Backdrop sx={{zIndex: theme => theme.zIndex.drawer + 1, color: "#fff"}} open={ loading}>
                <CircularProgress color={"inherit"}/>
            </Backdrop>
        </StyledContainer>
    )
}
